import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { CheckInSummaryModel } from "./check-ins-statuses";
import { IconComponent } from "../design-system/components/icon/icon.component";
import {
  SURVEY_ANNUAL,
  SURVEY_DAY_ONE, SURVEY_MONTH_FOUR,
  SURVEY_MONTH_ONE, SURVEY_MONTH_SIX,
  SURVEY_MONTH_THREE,
  SURVEY_MONTH_TWO,
  SURVEY_WEEK_ONE
} from "../utils/check-ins-summary.util";

export interface SurveysToDisplay {
  name: string;
  label: string;
  statusIcon: string;
}

@Component({
  selector: 'lib-check-ins-summary',
  standalone: true,
  imports: [
    IconComponent
  ],
  templateUrl: './check-ins-summary.component.html',
  styleUrl: './check-ins-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckInsSummaryComponent {


  readonly checkInsSummary = input<CheckInSummaryModel[] | null>(null);

  readonly surveysToDisplay = signal<any[]>([
    { name: SURVEY_DAY_ONE, label: '1d' },
    { name: SURVEY_WEEK_ONE, label: '1w' },
    { name: SURVEY_MONTH_ONE, label: '1m' },
    { name: SURVEY_MONTH_TWO, label: '2m' },
    { name: SURVEY_MONTH_THREE, label: '3m' },
    { name: SURVEY_MONTH_FOUR, label: '4m' },
    { name: SURVEY_MONTH_SIX, label: '6m' },
    { name: SURVEY_ANNUAL, label: '1y' }
  ]);

  readonly checkInsSummaryFormatted = computed((): SurveysToDisplay[] => {
    const checkIns = this.checkInsSummary();

    if (!checkIns) return [];

    return this.surveysToDisplay().map(s => ({
      ...s,
      statusIcon: checkIns.find(c => c.surveyTitle == s.name)?.statusIcon
        || 'checkInsStatusDefaultIcon'
    }));
  });
}
